// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const OpenSidebarIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="OpenSidebarIcon" ref={forwardedRef} {...props}>
      <path d="M11.422 7.172 14.25 10l-2.828 2.828-.92-.922 1.94-1.94-1.909-1.909z" />
      <path d="M7 7.25v1.833h1.5V7.25z" />
      <path d="M7 10.917v1.833h1.5v-1.833z" />
      <path d="M4 3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm.5 1.5H7v.917h1.5V4.5h7v11h-7v-.917H7V15.5H4.5z" />
    </SvgIcon>
  );
});

/**
 * Use to expand the sidebar. Use ChevronRightDoubleIcon for others
 * @public
 */
export const OpenSidebarIcon = /* @__PURE__ */ Object.assign(
  OpenSidebarIconComponent,
  { displayName: 'OpenSidebarIcon' },
);
